module.exports = __webpack_public_path__ + "img/building.a10eadc8.jpg";